module.exports = __webpack_public_path__ + "assets/img/ic-gift-r.04ff9095.svg";